'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Partner = /** @class */function () {
    function Partner() {
        this.partnerDom = document.getElementById('partner');
        this.init();
    }
    Partner.prototype.init = function () {
        this.toggleTab();
    };
    Partner.prototype.toggleTab = function () {
        var _this = this;
        var tabs = _tool2.default.$_selectAll(this.partnerDom, '.trusted-by-partner2 ul li');
        tabs.forEach(function (item) {
            item.addEventListener('click', function () {
                tabs.forEach(function (tItem) {
                    return tItem.classList.remove('active');
                });
                item.classList.add('active');
                var gid = item.getAttribute('data-gid');
                var className = "list".concat(gid);
                var listContainers = _tool2.default.$_selectAll(_this.partnerDom, '.list-box .list-container');
                listContainers.forEach(function (lItem) {
                    return lItem.classList.remove('show');
                });
                var listContainer = _tool2.default.$_select(_this.partnerDom, ".list-box .".concat(className));
                listContainer.classList.add('show');
            });
        });
        // 初始
        var firstTab = _tool2.default.$_select(this.partnerDom, '.trusted-by-partner2 ul li:first-child');
        firstTab.click();
    };
    return Partner;
}();
exports.default = Partner;